import { createContext } from 'use-context-selector';
const TopbarContext = createContext({});
export default TopbarContext;
